import { render, staticRenderFns } from "./FaizTuruPicker.vue?vue&type=template&id=92db82b4"
import script from "./FaizTuruPicker.vue?vue&type=script&lang=ts"
export * from "./FaizTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports